import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DiamondIcon from '@mui/icons-material/Diamond';

const MissionVisionValues = () => {
  return (
    <Box sx={{ background: '#0B0914', py: { xs: 10, md: 16 }, color: '#fff', position: 'relative', overflow: 'hidden' }}>
      
      {/* Background glow */}
      <Box sx={{ position: 'absolute', top: '10%', right: '-10%', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(108,77,226,0.05) 0%, rgba(11,9,20,0) 70%)', zIndex: 0 }} />
      <Box sx={{ position: 'absolute', bottom: '10%', left: '-10%', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(242,28,99,0.05) 0%, rgba(11,9,20,0) 70%)', zIndex: 0 }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box textAlign="center" mb={12}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Typography variant="caption" sx={{ color: '#F21C63', fontWeight: 'bold', letterSpacing: 3, textTransform: 'uppercase' }}>
              Nuestra Esencia
            </Typography>
            <Typography variant="h2" fontWeight={900} mt={2} mb={3}>
              El ADN de Hitpoly
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 700, mx: 'auto', fontSize: '1.2rem' }}>
              Más que una plataforma de software, somos un movimiento diseñado para transformar la forma en la que el mundo de los negocios opera y crece.
            </Typography>
          </motion.div>
        </Box>

        {/* 1. MISION (Texto Izquierda, Gráfico Derecha) */}
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center" mb={12}>
          <Grid item xs={12} md={6}>
            <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <Box display="flex" alignItems="center" mb={2}>
                <TrackChangesIcon sx={{ fontSize: 40, color: '#6C4DE2', mr: 2 }} />
                <Typography variant="h3" fontWeight={800}>Misión</Typography>
              </Box>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem', lineHeight: 1.8, mb: 4 }}>
                Democratizar el acceso al crecimiento empresarial y al desarrollo profesional eliminando por completo la fricción tecnológica.
                Construimos el puente perfecto entre las herramientas de alto rendimiento y el talento humano, permitiendo que cualquier negocio, sin importar su tamaño, pueda escalar agresivamente.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} style={{ width: '100%' }}>
              <Box 
                sx={{ 
                  height: { xs: 250, md: 350 }, 
                  width: '100%',
                  borderRadius: '30px', 
                  background: 'linear-gradient(135deg, rgba(108,77,226,0.2) 0%, rgba(108,77,226,0.05) 100%)',
                  border: '1px solid rgba(108,77,226,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <Box sx={{ width: '150px', height: '150px', borderRadius: '50%', background: 'rgba(108,77,226,0.4)', filter: 'blur(40px)', position: 'absolute' }} />
                <TrackChangesIcon sx={{ fontSize: 120, color: '#6C4DE2', zIndex: 1, opacity: 0.8 }} />
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        {/* 2. VISION (Gráfico Izquierda en desktop, Texto primero en mobile) */}
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center" mb={12}>
          {/* Texto - aparece primero en mobile (order 1), segundo en desktop (order 2) */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
            <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <Box display="flex" alignItems="center" mb={2}>
                <VisibilityIcon sx={{ fontSize: 40, color: '#F21C63', mr: 2 }} />
                <Typography variant="h3" fontWeight={800}>Visión</Typography>
              </Box>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem', lineHeight: 1.8, mb: 4 }}>
                Ser el ecosistema empresarial All-in-One estándar a nivel mundial. Visualizamos un futuro donde el caos de suscripciones y plataformas desconectadas desaparece, dando lugar a una única súper-aplicación donde aprender, operar y contratar ocurre en perfecta sincronía.
              </Typography>
            </motion.div>
          </Grid>
          {/* Gráfico - aparece segundo en mobile (order 2), primero en desktop (order 1) */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
            <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} style={{ width: '100%' }}>
              <Box 
                sx={{ 
                  height: { xs: 250, md: 350 }, 
                  width: '100%',
                  borderRadius: '30px', 
                  background: 'linear-gradient(135deg, rgba(242,28,99,0.2) 0%, rgba(242,28,99,0.05) 100%)',
                  border: '1px solid rgba(242,28,99,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <Box sx={{ width: '150px', height: '150px', borderRadius: '50%', background: 'rgba(242,28,99,0.4)', filter: 'blur(40px)', position: 'absolute' }} />
                <VisibilityIcon sx={{ fontSize: 120, color: '#F21C63', zIndex: 1, opacity: 0.8 }} />
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        {/* 3. VALORES (Tarjetas) */}
        <Box mb={4}>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={6}>
              <Typography variant="h3" fontWeight={800} textAlign="center">Valores Fundamentales</Typography>
            </Box>
          </motion.div>
        </Box>

        <Grid container spacing={4}>
          {[
            { title: 'Innovación Constante', desc: 'No nos conformamos con lo que existe. Iteramos y mejoramos nuestra tecnología todos los días.', color: '#29B6F6' },
            { title: 'Excelencia y Calidad', desc: 'Diseñamos interfaces premium y experiencias fluidas. Si no es de clase mundial, no lo lanzamos.', color: '#E67E22' },
            { title: 'Comunidad Primero', desc: 'El éxito de nuestros usuarios es el nuestro. Fomentamos la colaboración real sobre la competencia.', color: '#00A86B' }
          ].map((val, idx) => (
            <Grid item xs={12} md={4} key={idx}>
              <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.2 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 5,
                    height: '100%',
                    background: 'rgba(255,255,255,0.02)',
                    borderTop: `4px solid ${val.color}`,
                    borderRadius: '16px',
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'translateY(-10px)', background: 'rgba(255,255,255,0.04)' }
                  }}
                >
                  <Typography variant="h5" fontWeight="bold" mb={2} color={val.color}>{val.title}</Typography>
                  <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.7 }}>
                    {val.desc}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
};

export default MissionVisionValues;
